// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../@nuxt/webpack/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".display-none{display:none}.sf-loader{height:100%;position:relative;width:100%}.sf-loader__overlay{align-items:center;background:var(--loader-overlay-background,var(--c-white));bottom:0;display:flex;justify-content:center;left:0;position:absolute;right:0;top:0}.sf-loader__spinner{stroke:var(--loader-spinner-stroke,var(--c-primary))}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
